import React, { Fragment } from "react";
import { storekeeperForm } from "./data";
import { useTranslation } from "react-i18next";
import Storekeeper from "./Storekeeper";

const DepotStorekeepers = ({ forms, setForms }) => {
  const { t } = useTranslation("common");

  const getSelectValue = (value, options) => {
    if (typeof value === "object") {
      return value;
    }
    const currentOption = options.find((option) => option.code === value);
    if (currentOption) {
      return {
        name: t(`${currentOption.name}`),
        code: currentOption.code,
      };
    }
    return {};
  };

  const addNewElement = () => {
    setForms((prev) => ({
      ...prev,
      storekeepers: [...prev?.storekeepers, { user: {} }],
    }));
  };

  const handleChange = (index) => (e) => {
    const { value, name } = e.target;
    setForms((prev) => {
      const updatedFormData = [...prev?.storekeepers];

      const element = storekeeperForm.find((el) => el.name === name);
      if (element?.userField) {
        updatedFormData[index] = {
          ...updatedFormData[index],
          user: {
            ...updatedFormData[index].user,
            [name]: value,
          },
        };
      } else {
        updatedFormData[index] = {
          ...updatedFormData[index],
          [name]: value,
        };
      }

      return {
        ...prev,
        storekeepers: updatedFormData,
      };
    });
  };

  const handleDelete = (index, storekeeper) => () => {
    setForms((prev) => {
      const updatedFormData = [...prev?.storekeepers];
      updatedFormData.splice(index, 1);
      return {
        ...prev,
        storekeepers: updatedFormData,
      };
    });
  };

  return (
    <div className="flex-1 d-flex flex-column">
      <div className="modalContent px-5 pt-4 pb-5 d-flex flex-column">
        {forms?.storekeepers.map((storekeeper, index) => (
          <>
            <div className="row gy-2">
              {storekeeperForm.map((el) => (
                <Fragment key={el?.name}>
                  <Storekeeper
                    el={el}
                    index={index}
                    storekeeper={storekeeper}
                    handleChange={handleChange}
                    getSelectValue={getSelectValue}
                  />
                </Fragment>
              ))}
            </div>
            <div className="d-flex justify-content-end mt-3">
              <button
                className="d-flex align-items-center justify-content-center border-0 px-2 py-1 br5 bg-dimGrey"
                onClick={handleDelete(index, storekeeper)}
              >
                <i className="bi bi-trash" />
              </button>
            </div>
            <hr
              style={{ borderColor: "#abb8b2", margin: 0 }}
              className="my-4"
            />
          </>
        ))}
        <div
          className="br5 w-50 cursor-pointer shadow alignC p-2 pb-4"
          onClick={addNewElement}
        >
          <div className="w-50 alignC flex-column h100 bold text-center">
            <i className="bi bi-plus f50 text-brightGrey"></i>
            <span className="f14 text-brightGrey">{t("Add storekeeper")} </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DepotStorekeepers;
